import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap'
import { ButtonModule, LoaderModule, NfFormsModule } from '@northfork/ng-basics'
import { AgoPipe } from './ago/ago.pipe'
import { AppliedFilterCountsComponent } from './applied-filter-counts/applied-filter-counts.component'
import { CacheLoadListenerComponent } from './cache-load-listener/cache-load-listener.component'
import { ContentConditionGuardComponent } from './content-guards/content-condition-guard/content-condition-guard.component'
import { NoFocusedAggregateComponent } from './content-guards/no-focused-aggregate/no-focused-aggregate.component'
import { NoLoadedAccountComponent } from './content-guards/no-loaded-account/no-loaded-account.component'
import { NoLoadedOrFocusedAccountComponent } from './content-guards/no-loaded-or-focused-account/no-loaded-or-focused-account.component'
import { NoSelectedAccountComponent } from './content-guards/no-selected-account/no-selected-account.component'
import { CustomLoaderComponent } from './custom-loader/custom-loader.component'
import { DialogErrorDetailsComponent } from './dialog-error-details/dialog-error-details.component'
import { AutofocusDirective } from './directives/autofocus.directive'
import { DraggableDirective } from './directives/draggable.directive'
import { OutsideClickDirective } from './directives/outside-click.directive'
import { ResizableDirective } from './directives/resizable.directive'
import { EditTransactionNoteModalComponent } from './edit-transaction-note-modal/edit-transaction-note-modal.component'
import { GenericConfirmationModalComponent } from './generic-confirmation-modal/generic-confirmation-modal.component'
import { GenericDeleteConfirmationModalComponent } from './generic-delete-confirmation-modal/generic-delete-confirmation-modal.component'
import { InvalidTransactionIdPopoverComponent } from './invalid-transaction-id-popover/invalid-transaction-id-popover.component'
import { InvalidTransactionIdPopoverService } from './invalid-transaction-id-popover/invalid-transaction-id-popover.service'
import { LazyLoadPanelComponent } from './lazy-load-panel/lazy-load-panel.component'
import { PanelCardComponent } from './panel-card/panel-card.component'
import { PanelSettingsToolPanelComponent } from './panel-settings-tool-panel/panel-settings-tool-panel.component'
import { SecuritiesSelectedComponent } from './securities-selected/securities-selected.component'
import { SingleAccountSelectedComponent } from './single-account-selected/single-account-selected.component'
import { TransactionDeleteModalComponent } from './transaction-delete-modal/transaction-delete-modal.component'
import { TransactionDeleteNoteModalComponent } from './transaction-delete-note-modal/transaction-delete-note-modal.component'
import { TruncatePipe } from './truncate/truncate.pipe'

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    LoaderModule,
    ReactiveFormsModule,
    ButtonModule,
    NfFormsModule,
    NgbAccordionModule,
    FormsModule,
  ],
  declarations: [
    NoLoadedAccountComponent,
    NoSelectedAccountComponent,
    PanelCardComponent,
    DraggableDirective,
    AutofocusDirective,
    CacheLoadListenerComponent,
    SecuritiesSelectedComponent,
    SingleAccountSelectedComponent,
    AgoPipe,
    AppliedFilterCountsComponent,
    TransactionDeleteModalComponent,
    TransactionDeleteNoteModalComponent,
    LazyLoadPanelComponent,
    ContentConditionGuardComponent,
    NoLoadedOrFocusedAccountComponent,
    ResizableDirective,
    OutsideClickDirective,
    CustomLoaderComponent,
    PanelSettingsToolPanelComponent,
    DialogErrorDetailsComponent,
    EditTransactionNoteModalComponent,
    InvalidTransactionIdPopoverComponent,
    GenericDeleteConfirmationModalComponent,
    GenericConfirmationModalComponent,
    TruncatePipe,
    NoFocusedAggregateComponent,
  ],
  exports: [
    NoLoadedAccountComponent,
    NoSelectedAccountComponent,
    PanelCardComponent,
    DraggableDirective,
    ResizableDirective,
    AutofocusDirective,
    OutsideClickDirective,
    CacheLoadListenerComponent,
    SecuritiesSelectedComponent,
    SingleAccountSelectedComponent,
    AgoPipe,
    AppliedFilterCountsComponent,
    TransactionDeleteModalComponent,
    TransactionDeleteNoteModalComponent,
    LazyLoadPanelComponent,
    NoLoadedOrFocusedAccountComponent,
    CustomLoaderComponent,
    PanelSettingsToolPanelComponent,
    DialogErrorDetailsComponent,
    EditTransactionNoteModalComponent,
    GenericDeleteConfirmationModalComponent,
    GenericConfirmationModalComponent,
    TruncatePipe,
    NoFocusedAggregateComponent,
  ],
  providers: [InvalidTransactionIdPopoverService],
})
export class GenericComponentsModule {}
